/** Approximate wallet availability, as generated by Claude. This isn't the actual wallet availability that Adyen would
 * report, but simply powers the dummy payment options that are displayed before Adyen loads
 */
export function getWalletAvailability() {
  if (typeof window === 'undefined') {
    return {
      showApplePay: false,
      showGooglePay: false,
    };
  }

  try {
    const ua = navigator.userAgent;

    // Operating systems. iPadOS reports itself as "Macintosh", so use touch support to tell it apart
    const isIPadOS = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
    const isIOS = /iPhone|iPad|iPod/i.test(ua) || isIPadOS;
    const isMacOS = /Macintosh|Mac OS X/i.test(ua) && !isIOS;
    const isAndroid = /Android/i.test(ua);
    const _isWindows = /Windows/i.test(ua);
    const _isLinux = /Linux/i.test(ua) && !isAndroid;
    const _isChromeOS = /CrOS/i.test(ua);

    // Browsers. Most UAs include "Chrome" and/or "Safari", so check the specific ones first
    const isEdge = /Edg\/|EdgA\/|EdgiOS/i.test(ua);
    const isOpera = /OPR\/|OPiOS/i.test(ua);
    const isSamsungInternet = /SamsungBrowser/i.test(ua);
    const isFirefox = /Firefox|FxiOS/i.test(ua);
    const isChrome =
      /Chrome|CriOS/i.test(ua) && !isEdge && !isOpera && !isSamsungInternet;
    const isSafari =
      /Safari/i.test(ua) &&
      !isChrome &&
      !isEdge &&
      !isOpera &&
      !isSamsungInternet &&
      !isFirefox &&
      !isAndroid;

    const showApplePay =
      (isMacOS && isSafari) || (isIOS && (isSafari || isChrome || isEdge));

    const showGooglePay =
      !isIOS &&
      !isSafari &&
      (isAndroid ||
        isChrome ||
        isEdge ||
        isFirefox ||
        isOpera ||
        isSamsungInternet);

    return { showApplePay, showGooglePay };
  } catch {
    return {
      showApplePay: false,
      showGooglePay: false,
    };
  }
}
